import { normalize, schema } from "normalizr";
import { SubmissionError } from "redux-form";
import { put } from "superagent";
import { apiPut, baseUrl } from "./helpers/api";
import middleware from "./helpers/railsMiddleware";
import { notifySubmitError, notifySubmitSucceeded } from "./notifierProcesses";

export const user = new schema.Entity("users");

const isFile = (obj) => obj && !!obj.lastModified;

export const updatedUser = (dispatch, response) => {
  dispatch({
    type: "USER_UPDATED",
    ...normalize(response.body.data, user),
  });
};

const updateUserImage = (image, type, dispatch) => {
  const req = put(`${baseUrl}/api/v1/auth`).use(middleware);
  req.attach(type, image);
  return req
    .then((response) => {
      updatedUser(dispatch, response);
    })
    .catch((err) => {
      throw new SubmissionError({ _error: err.response?.body?.errors });
    });
};

export const updateProfile = async (
  // eslint-disable-next-line no-unused-vars
  { avatarUrl, coverUrl, ...attrs },
  dispatch
) => {
  if (isFile(avatarUrl)) {
    await updateUserImage(avatarUrl, "avatar", dispatch);
  }

  return apiPut("/api/v1/auth")
    .send(attrs)
    .then((response) => {
      updatedUser(dispatch, response);
      notifySubmitSucceeded(
        dispatch,
        "Uhuu, Seu perfil foi atualizado com sucesso!"
      );
    })
    .catch((err) => {
      notifySubmitError(dispatch, {
        message: "Dados de senha inválidos.",
      });
      throw new SubmissionError({
        _error: err.response?.body?.errors?.full_messages?.[0] || 'Erro de conexão. Tente novamente.',
      });
    });
};

export const updateBillingDetails = async (attrs, dispatch) => {
  const billingAttrs = { ...attrs };
  [
    "resolvedCityName",
    "resolvedStateName",
    "searchedAddress",
    "searchedAddressNeighborhood",
    "searchedAddressZip",
    "searchedCityId",
    "searchedStateId",
    "searchingAddress",
  ].forEach((key) => delete billingAttrs[key]);

  // Don't send an empty cityId — it would clear the user's existing city in the DB
  if (!billingAttrs.cityId) delete billingAttrs.cityId;

  return apiPut("/api/v1/auth")
    .send(billingAttrs)
    .then((response) => {
      updatedUser(dispatch, response);
      const responseData = response.body.data;
      dispatch({
        type: "USER_BILLING_DETAILS_UPDATED",
        userId: responseData.id,
        attributes: {
          ...billingAttrs,
          cityName: responseData.cityName,
          stateName: responseData.stateName,
          stateUf: responseData.stateUf,
          stateId: responseData.stateId,
        },
      });
      notifySubmitSucceeded(
        dispatch,
        "Dados de cobrança atualizados com sucesso!"
      );
    })
    .catch((err) => {
      notifySubmitError(dispatch, {
        message: "Não foi possível atualizar seus dados de cobrança.",
      });
      throw new SubmissionError({
        _error: err.response?.body?.errors?.full_messages?.[0] || 'Erro de conexão. Tente novamente.',
      });
    });
};
